import React, { useState } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import api from '../../../api/api';

export default function CanonicalCandidateList({ disabled, onSelect }) {
  const [page, setPage] = useState(0);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function load(nextPage) {
    if (busy || disabled) return;
    setBusy(true);
    setError('');
    try {
      const response = await api.getAuth('/admin/direct-catalog/canonical-candidates', {
        params: { page: nextPage },
      });
      setPage(nextPage);
      setResult(response.data.data);
    } catch (e) {
      setError(e.message || '후보 조회 실패');
    } finally {
      setBusy(false);
    }
  }
  return (
    <Stack spacing={1}>
      <Button disabled={disabled || busy} onClick={() => load(0)}>
        현재 수집 DB에서 중복 후보 찾기
      </Button>
      <Typography variant="caption">
        수동 앨범을 20개씩 검사합니다. 새로 수집된 공식 앨범도 조회 시 반영됩니다. 제목·아티스트
        일치 후보이며 동일 판본 확정은 아닙니다. 후보가 없거나 다른 표기라면 아래 개별 검색을
        이용해주세요.
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {result?.items?.map(({ manual, official }) => (
        <Button
          key={`${manual.albumId}-${official.albumId}`}
          disabled={disabled || busy}
          onClick={() => onSelect(manual, official)}
        >
          {manual.title} · {manual.artistName} (수동 #{manual.albumId} → 공식 #{official.albumId})
        </Button>
      ))}
      {result?.items?.length === 0 && <Typography>이 구간에는 일치 후보가 없습니다.</Typography>}
      {result && (
        <Stack direction="row">
          <Button disabled={disabled || busy || page === 0} onClick={() => load(page - 1)}>
            이전 구간
          </Button>
          <Button disabled={disabled || busy || !result.hasMore} onClick={() => load(page + 1)}>
            다음 구간
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
